function escapeHtmlText(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeHtmlAttr(value) {
  return escapeHtmlText(value).replace(/"/g, '&quot;');
}

function escapeRegex(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceMeta(html, attribute, attributeValue, content) {
  const tag = `<meta ${attribute}="${attributeValue}" content="${escapeHtmlAttr(content)}" />`;
  const pattern = new RegExp(
    `<meta\\b(?=[^>]*\\b${attribute}\\s*=\\s*"${escapeRegex(attributeValue)}")[^>]*>`,
    'i'
  );
  return html.replace(pattern, tag);
}

function applyRobotsMeta(html, robots) {
  if (!robots) {
    return html;
  }
  const hasNoindex = /<meta\s+name="robots"\s+content="[^"]*noindex/i.test(html);
  // Staging already injects noindex. An indexable profile must not remove it.
  if (hasNoindex && !/noindex/i.test(robots)) {
    return html;
  }
  const tag = `<meta name="robots" content="${escapeHtmlAttr(robots)}" />`;
  if (!/<meta\s+name="robots"/i.test(html)) {
    return html.replace('</head>', `${tag}\n</head>`);
  }
  if (/noindex/i.test(robots)) {
    return html.replace(
      /<meta\s+name="robots"\s+content="(?![^"]*noindex)[^"]*"\s*\/?>/i,
      tag
    );
  }
  return html.replace(/<meta\s+name="robots"\s+content="[^"]*"\s*\/?>/i, tag);
}

const { injectHomeFaqScript } = require('./homeFaq');

function applySeoToHtml(html, seo, options) {
  const includeCrawlerSummary = Boolean(options && options.includeCrawlerSummary);
  let next = html;
  next = next.replace(/<title>[\s\S]*?<\/title>/i, `<title>${escapeHtmlText(seo.title)}</title>`);
  next = replaceMeta(next, 'name', 'description', seo.description);
  next = replaceMeta(next, 'property', 'og:title', seo.title);
  next = replaceMeta(next, 'property', 'og:description', seo.description);
  next = replaceMeta(next, 'property', 'og:url', seo.canonicalUrl);
  next = replaceMeta(next, 'name', 'twitter:title', seo.title);
  next = replaceMeta(next, 'name', 'twitter:description', seo.description);
  next = next.replace(
    /<link\b(?=[^>]*\brel\s*=\s*"canonical")[^>]*>/i,
    `<link rel="canonical" href="${escapeHtmlAttr(seo.canonicalUrl)}" />`
  );
  next = applyRobotsMeta(next, seo.robots);
  if (seo.imageUrl) {
    next = replaceMeta(next, 'property', 'og:image', seo.imageUrl);
    next = replaceMeta(next, 'property', 'og:image:alt', seo.imageAlt || seo.title);
    next = replaceMeta(next, 'name', 'twitter:image', seo.imageUrl);
    next = replaceMeta(next, 'name', 'twitter:image:alt', seo.imageAlt || seo.title);
  }
  if (seo.includeHomeFaq) {
    next = injectHomeFaqScript(next);
  }
  if (includeCrawlerSummary && seo.heading && seo.paragraph) {
    const summary =
      `<div id="crawler-page-summary"><h1>${escapeHtmlText(seo.heading)}</h1><p>${escapeHtmlText(seo.paragraph)}</p></div>\n    `;
    next = next.replace('<div id="root"></div>', `${summary}<div id="root"></div>`);
  }
  return next;
}

module.exports = {
  applySeoToHtml,
};
